import TemplateView from '../../../TemplateView'
import {reactOnErrorMessage} from '../../../components/validation/utils'

/**
 * Wrapper over HTML <label>. Probably could be moved to common components
 */
export default class InputLabel extends TemplateView {
    constructor({
        text = "",
        forId = null,
        additionalClass = "",
        errorMessage = ""
    }) {
        super();
        this.state = {
            text, errorMessage
        }
        this.text = text;
        this.forId = forId;
        this.additionalClass = additionalClass;

        reactOnErrorMessage(this, {addTitle: false});
    }

    templateHtml() {
        return `
            <label class="components_label <%=additionalClass%>">
                <%=text%>
            </label>`
    }

    afterRender() {
        if (this.forId) {
            this.$el.attr("for", this.forId);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/components/InputLabel.js